/**
 * ** SabeeApp**
 *
 * @exports bs_432
 * @category engines
 */
function factory({ window, document, thn }) {

  const engine = {};

  /**
   * @memberOf module:bs_432
   * @see {@link language_check}
   *
   * @param {object} ctx - The context object.
   */
  engine.languageCheck = function languageCheck(ctx) {

    return new Promise(function (resolve, reject) {
      const lang = document.getElementById('languages')?.value?.toLowerCase();
      if (lang && ctx.langs.test(lang)) {
        resolve(lang);
        return;
      }
      reject('no_language');
    });
  };

  /**
   * @memberOf module:bs_432
   * @see {@link generateSearchUrl}
   *
   * @param {object} ctx - The context object.
   */
  engine.generateSearchUrl = function generateSearchUrl(ctx) {
    const url = new URL(ctx.baseUrl);
    const validaUrl = url.hostname.match(/ibe\.sabeeapp/);

    // https://ibe.sabeeapp.com/properties/Dominic-Smart-Luxury-Suites-booking/?checkin=2024-09-17&checkout=2024-09-19&adults=1&children=1&infants=0&l=en
    if (!validaUrl) {
      ctx.newUrl = '';
      return ctx;
    }

    const searchParams = new URLSearchParams(url.search);
    searchParams.set('l', '[language]');
    searchParams.set('checkin', '[date_begin]');
    searchParams.set('checkout', '[date_end]');
    searchParams.set('adults', '[adults]');
    searchParams.set('children', '[children]');
    searchParams.set('infants', '0');
    ctx.newData.dateBegin = ctx.data.dateBegin.replace(/\//g, '-');
    ctx.newData.dateEnd = ctx.data.dateEnd.replace(/\//g, '-');
    url.search = searchParams.toString();

    ctx.newUrl = url.toString();

    return ctx;
  };

  /**
     * @memberOf module:bs_432
     * @this thn.widgets.price
     * @see {@link Price#observe_dom}
     *
     * @param {object} ctx - The context object.
     */
  engine.priceObserveDom = function priceObserveDom(ctx) {
    const container = document.querySelector('#roomsfororder');

    if (container) {
      let priceRefresh = thn.debounce(() => ctx.widget.refresh(), 400);

      thn.observeDom(container, priceRefresh, {
        childList: true,
        subtree: true,
        attributes: true,
        characterData: true,
      });

      thn.pageUnload(() => {
        priceRefresh.cancel();
        thn.stopObserveDom(container, priceRefresh);
        priceRefresh = null;
      });
    }
  };
  /**
   * @memberOf module:bs_432
   * @this thn.widgets.price
   * @see {@link Price#set_data}
   *
   * @param {object} ctx - The context object.
   */
  engine.priceParseData = function priceParseData(ctx) {

    const widgetData = {};

    const dateBegin = thn.parseUrlParameter('checkin')?.replace(/-/g, '/');
    const dateEnd = thn.parseUrlParameter('checkout')?.replace(/-/g, '/');
    let nights;

    if (dateBegin && dateEnd) {
      widgetData.dateBegin = dateBegin;
      widgetData.dateEnd = dateEnd;
      nights = thn.daysBetween(dateBegin, dateEnd);
    }
    // Guests, Adults & Children
    widgetData.adults = thn.parseNumber(document.querySelector('#adults')?.value) || 2;
    widgetData.children = thn.parseNumber(document.querySelector('#children')?.value) || 0;
    widgetData.guests = widgetData.adults + widgetData.children;

    // Prices & Currency || No Rooms
    const prices = [...document.querySelectorAll('.fs24')].map((price) => thn.parseNumber(price?.textContent))?.filter(Boolean);
    const currency = thn.parseCurrency(document.querySelector('.selected')?.innerText);
    const loaderEl = !!document.querySelector('.xloading-container');

    if (!thn.empty(prices) && currency && nights) {
      widgetData.price = Math.min(...prices) / nights;
      widgetData.currency = currency;
      widgetData.set = true;
    } else if (thn.empty(prices) && !loaderEl) {
      widgetData.noRooms = true;
    }

    return widgetData;
  };

  /**
   * @memberOf module:bs_432
   * @this thn.widgets.booking
   * @see {@link Booking#set_data}
   *
   * @param {object} ctx - The context object.
   */
  engine.bookingParseData = function bookingParseData(ctx) {

    const widgetData = {};
    const dataLayer = window.dataLayer;
    const bookingId = document.querySelector('div.col-lg-6 p span')?.textContent;
    const textGuests = document.querySelector('.confirmationPageContent p:nth-child(5)')?.lastChild?.textContent;
    const adults = textGuests?.match(/\d+/g)[0];
    const price = document.querySelector('.col-lg-12 #ordered table tbody tr td:nth-child(5)')?.textContent;

    if (!dataLayer || !bookingId) {
      widgetData.set = false;
      return widgetData;
    }
    widgetData.dateBegin = document.querySelector('.col-lg-12 #ordered table tbody tr td:nth-child(2)')?.innerText?.replace(/(\d{2})-(\d{2})-(\d{4})/g, '$3/$2/$1');
    widgetData.dateEnd = document.querySelector('.col-lg-12 #ordered table tbody tr td:nth-child(3)')?.innerText?.replace(/(\d{2})-(\d{2})-(\d{4})/g, '$3/$2/$1');
    widgetData.adults = thn.parseNumber(adults);
    widgetData.price = thn.parseNumber(price);
    widgetData.currency = thn.parseCurrency(price);
    widgetData.bookingId = bookingId;

    return widgetData;
  };

  return engine;

}

export { factory };
